import { useContext, useEffect, useRef } from "react";
import { SWIVU_HOME_VIEW } from "../../other/constants/OtherKeys.jsx";
import AuthContext from "../context/authContext.jsx";
import BryntumContext from "../context/bryntumContext.jsx";

const useDisplayHomeModal = () => {
  const user = useContext(AuthContext);
  const { isAppLoaded, selectedBoard, boardManager, project } = useContext(BryntumContext);
  const { setDisplayAuthForm, isNewSessionRef } = useContext(AuthContext);
  // we want to display swivu home modal only if we didn't already display it, so when switching board it should not appear
  const isSwivuHomeDisplayed = useRef(false);

  // Board-user interrupt popup removed — Notable / interrupt updates surface in Updates only.

  useEffect(() => {
    // Swivu Home Modal popup handling
    const canDisplaySwivuHomeModal = isNewSessionRef.current && isAppLoaded && user.user && (!isSwivuHomeDisplayed.current || selectedBoard?.record?.isSandbox);
    if (canDisplaySwivuHomeModal) {
      const homeModalData = {
        selectedBoard: selectedBoard.record,
        boards: boardManager.boardNameStore.records,
        recentInvites: user.user.recent_invites,
        onBoardSelected: (board) => boardManager.changeSelectedBoard(board),
      };
      const isSandboxBoard = user.user.isDemoUser || selectedBoard.record.isSandbox;
      setDisplayAuthForm({
        type: isSandboxBoard ? SWIVU_HOME_VIEW.sandbox: SWIVU_HOME_VIEW.welcome,
        data: homeModalData
      });
      isSwivuHomeDisplayed.current = true;
      isNewSessionRef.current = false;
    }

    if (!user?.user) isSwivuHomeDisplayed.current = false;
  }, [isAppLoaded, selectedBoard, boardManager.boardNameStore, user.user, project, setDisplayAuthForm, isNewSessionRef])
};

export default useDisplayHomeModal;
